<div class="modal-body">
	<div class="modal-header">
		<h2 class="modal-title" [innerHtml]="title"></h2>
		<button type="button" class="btn btn-close" aria-label="Cancel" (click)="close()" data-cy="closeEditTemplate">
			<i class="fal fa-xmark"></i>
		</button>
	</div>
	@if (formLoaded && form) {
		<form (ngSubmit)="submit($event)" class="fade-in">
			<div class="modal-body">
				<div class="char-data__group">
					@if (_charTypeId === 3 && _templateId) {
						<div>
							<div class="alert alert-warning my-3 d-inline-block" role="alert">
								Making changes here and saving could result in an automated avails refresh for your
								instance.
								Please proceed with discretion.</div>
						</div>
					}
					@if (form.controls.templateId) {
						<rl-form-table-row [labelText]="'Template ID'">
							<ng-template rlFormTableControl>
								<rl-text-input [(formControl)]="form.controls.templateId"
									[displayAsText]="form.controls.templateId"
									[dataLabel]="'templateIdInput'"></rl-text-input>
							</ng-template>
						</rl-form-table-row>
					}
					<rl-form-table-row [labelText]="'Template Name'" [required]="true"
						[class.has-error]="form.controls.templateName.invalid && form.controls.templateName.touched">
						<ng-template rlFormTableControl>
							<rl-text-input [(formControl)]="form.controls.templateName"
								[dataLabel]="'templateNameInput'"></rl-text-input>
						</ng-template>
						@if (form.controls.templateName.errors?.required && form.controls.templateName.touched) {
							<ng-template rlFormTableMessage>
								Template Name is required.
							</ng-template>
						}
						@if (form.controls.templateName.errors?.templateNameDuplicate) {
							<ng-template rlFormTableMessage>
								Duplicate Template Name is not allowed.
							</ng-template>
						}
					</rl-form-table-row>
					<rl-form-table-row [labelText]="'Template Group'">
						<ng-template rlFormTableControl>
							<rl-dropdown-single [(formControl)]="form.controls.templateGroup" [options]="groups"
								[showEmptyOption]="true" [dataLabel]="'selectTemplateGroup'">
							</rl-dropdown-single>
						</ng-template>
					</rl-form-table-row>
					<rl-form-table-row [labelText]="'Workflow Process'">
						<ng-template rlFormTableControl>
							<rl-dropdown-single [(formControl)]="form.controls.workflowProcess" [options]="processes"
								[showEmptyOption]="false" [dataLabel]="'selectWorkflowProcess'">
							</rl-dropdown-single>
						</ng-template>
					</rl-form-table-row>
					@if (_charTypeId === 3) {
						<rl-form-table-row [labelText]="'Deal Scoped'">
							<ng-template rlFormTableControl>
								<rl-dropdown-single [(formControl)]="form.controls.dealScoped"
									[options]="dealScopedOptionsList" [showEmptyOption]="false"
									[dataLabel]="'selectDealScoped'">
								</rl-dropdown-single>
							</ng-template>
						</rl-form-table-row>
					}
					@if (form.controls.systemIndicator) {
						<rl-form-table-row [labelText]="'System Indicator'">
							<ng-template rlFormTableControl>
								<rl-number-input [formControl]="form.controls.systemIndicator"
									[dataLabel]="'systemIndicatorInput'"></rl-number-input>
							</ng-template>
						</rl-form-table-row>
					}
					<rl-form-table-row [labelText]="'Calc Sequence'">
						<ng-template rlFormTableControl>
							<rl-number-input [formControl]="form.controls.calcSequence"
								[dataLabel]="'calcSequenceInput'"></rl-number-input>
						</ng-template>
					</rl-form-table-row>
					@if (form.controls.charTypeId.value === 3) {
						<rl-form-table-row [labelText]="'Color'">
							<ng-template rlFormTableControl>
								<rl-color-picker-input
									[formControl]="form.controls.visualization"></rl-color-picker-input>
							</ng-template>
						</rl-form-table-row>
					}
					@if (isDeal) {
						<rl-form-table-row labelText="Amortization Model">
							<ng-template rlFormTableControl>
								@if(amortOptions.items.length > 0) {
									<rl-dropdown-multiple [formControl]="form.controls.selectedAmortModels"
										[options]="amortOptions" [showEmptyOption]="true">
									</rl-dropdown-multiple>
								} @else {
									<label>
										<input type="checkbox" class="form-check-input" [ngModel]="true"
											[disabled]="true" [ngModelOptions]="{standalone: true}" />
										Straight Line
									</label>
								}
							</ng-template>
						</rl-form-table-row>
					}
					@if (showLockingLogic) {
						<rl-form-table-row labelText="Locking Logic">
							<ng-template rlFormTableControl>
								<rl-dropdown-single [(formControl)]="form.controls.lockLogicIndicator"
									[options]="componentLockLogicOptions" [showEmptyOption]="false"
									[dataLabel]="'selectLockLogicDropdown'">
								</rl-dropdown-single>
							</ng-template>
						</rl-form-table-row>
					}
				</div>
				@if (isConfigEditLocked) {
					<div class="px-3 pb-3">
						<div class="alert alert-warning mb-0" role="alert">
							This template is required by the Generated Payment configuration and cannot be modified.
						</div>
					</div>
				}
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-light" (click)="close()"
					data-cy="cancelTemplateEdit">Cancel</button>
				<button type="submit" class="btn btn-success"
					[disabled]="form.invalid || isSaving || isConfigEditLocked" data-cy="saveTemplateEdit">Save</button>
			</div>
		</form>
	} @else {
		<div class="modal-body fade-in">
			<rl-form-placeholder [numRows]="_templateId !== null ? 6 : 5"></rl-form-placeholder>
		</div>
	}
</div>